const mutations= {
  // 活動旗幟
  updateEventBanners(state,res){
    let newArray = res.filter(element => element.typeId == 1)
    if(newArray.length!=0){
      state.eventBanners = newArray[0].banners
    }
    // console.log('活動KV updated')
  },
  // 活動入口圖案
  updateCurationList(state,res){
    let newArray = res.filter(element => element.typeId == 2)
    if(newArray.length!=0){
      state.curationList = newArray[0].icons
    }
    // console.log('策展入口圖標 updated')
  },
  // 熱銷商品
  updateTopSale(state,res){
    let newArray = res.filter(element => element.typeId == 3)
    if(newArray.length!=0){
      state.topSale = newArray[0].deals;
      // console.log('Top熱銷 updated');
    }
  },
  // 檔期策展區與商品
  updateCurationEvents(state,res){
    let newArray = res.filter(element => element.typeId == 4)
    if(newArray.length!=0){
      state.curationEvents = newArray
    }
    // console.log('策展商品 updated')
  },
  // 一般類別商品
  updateNormalEvents(state,res){
    let newArray = res.filter(element => element.typeId == 5)
    if(newArray.length!=0){
      state.normalEvents = newArray
    }
    // console.log('一般策展 updated')
  },
  // 猜喜歡商品區
  updateCrmProducts(state,res){
    let newArray = res.filter(element => element.typeId == 6)
    if(newArray.length!=0){
      state.crmProducts = newArray[0].deals
    }
    // console.log('CRM商品 updated')
  },
  // 關閉資料讀取中狀態
  disableInitialLoading(state){
    // 將初始讀取中變成否
    state.initialLoading = false
  },
  // 加入新猜喜歡商品
  appendCrmProducts(state,res){
    let newArray = res
    if(newArray.length!=0){
      state.crmProducts = state.crmProducts.concat(newArray);
      this.state.crmLoaded = true;
    }
    // console.log('CRM商品 inserted')
  },
  // 更新側邊欄號碼
  updateCategoryNumber(state,number){
    state.categoryInitialNumber = number
  },
  // 更新側邊欄欄目項目
  updateCategoryTabs(state,res){
    // console.log(res)
    let newArray = res.categoryItem;
    let newArrayLinks = res.linkItem;
    state.categoryTabs = newArray
    state.categoryTabsLinks = newArrayLinks
    if(state.categoryInitialNumber==null){
      state.categoryInitialNumber = res.categoryItem[0].channelId;
    }
  },
  // 更新側邊欄對應內容
  updateCategoryContent(state,res){
    let newObject = res
    state.categoryContent = newObject;
  },
  // 更新會員內容
  updateMemberInfo(state,res){
    let newObject = res
    state.memberInfo = newObject.user
    window.$cookies.set('userId',newObject.user.userId,0);
    // 操作cookie(暫時不用) 
    // document.cookie = "isAuthenticated = "+state.memberInfo.isAuthenticated+";"
    // console.log(state.memberInfo)
  },
  // 更新加入最愛狀態
  updateCollectSuccess(state,res){
    state.collectSuccess = res.status
  },
  // 更新蓋版廣告
  updateOverlayAds(state,res){
    if(window.$cookies.get('EventEmailCookie') != null){
      // cookie exists, decide if it had the same id as the one from request
      if(res.Id == window.$cookies.get('EventEmailCookie')){
        state.overlayAdsAvailable = false;
        // console.log('略過廣告' + res.Id + '/' + window.$cookies.get('EventEmailCookie'));
      } else {
        state.overlayAdsAvailable = true;
        state.overlayAdsCountdown = res.AutoCoseSeconds || 5;
        // console.log('因為廣告事件更新，顯示廣告')
      }
    } else {
      // no cookie exists, show the ads
      // console.log('顯示廣告')
      state.overlayAdsAvailable = true;
      state.overlayAdsCountdown = res.AutoCoseSeconds || 5;
      window.$cookies.set('EventEmailCookie',res.Id, res.QuietSeconds * 1000);
    }
    state.overlayAds = res
  }
}

export default{
  mutations
}